export { default as Alert } from './alert';
export { default as UploadImage } from './uploadImage';
export { default as View } from './view';
